import { FormControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

import { AccountIdField } from '../models/user.model';

export const facebookUsernameValidator = Validators.pattern('[a-zA-Z0-9.]*');
export const instagramUsernameValidator = Validators.pattern('[a-zA-Z0-9._]*');
export const discordUsernameValidator: ValidatorFn = (c: FormControl): ValidationErrors | null => {
  const OLD_DISCORD_USERNAME_REGEX = /^.*#[0-9]{4}$/;
  const NEW_DISCORD_USERNAME_REGEX = /^[a-z0-9._]*$/;
  return ((OLD_DISCORD_USERNAME_REGEX.test(c.value) || NEW_DISCORD_USERNAME_REGEX.test(c.value)) ? null :
    { pattern: { valid: false } });
};
export const linkedinUsernameValidator = Validators.pattern(/^[\p{L}\p{M}0-9-]*$/u);
export const mortyAppUsernameValidator = Validators.pattern('[a-zA-Z0-9]*');
export const escapeTheReviewUserIdValidator = Validators.pattern('[0-9]*');
export const escapeAllGrUserIdValidator = Validators.pattern('[a-f0-9-]*');
export const escapeGameFrUserIdValidator = Validators.pattern('[a-zA-Z0-9._-]*');
export const escapeRoomersUserIdValidator = Validators.pattern('[0-9]+x[0-9]+');
export const escapeTalkNlUserIdValidator = Validators.pattern('[a-z0-9_]*');
export const lockMeUserIdValidator = Validators.pattern('[0-9]*');
export const theEscapersUserIdValidator = Validators.pattern('[a-z0-9-]*');

export const ACCOUNT_ID_VALIDATORS: Record<AccountIdField, ValidatorFn> = {
  facebookUsername: facebookUsernameValidator,
  instagramUsername: instagramUsernameValidator,
  discordUsername: discordUsernameValidator,
  linkedinUsername: linkedinUsernameValidator,
  mortyAppUsername: mortyAppUsernameValidator,
  escapeTheReviewUserId: escapeTheReviewUserIdValidator,
  escapeAllGrUserId: escapeAllGrUserIdValidator,
  escapeGameFrUserId: escapeGameFrUserIdValidator,
  escapeRoomersUserId: escapeRoomersUserIdValidator,
  escapeTalkNlUserId: escapeTalkNlUserIdValidator,
  lockMeUserId: lockMeUserIdValidator,
  theEscapersUserId: theEscapersUserIdValidator
};
